/* ----------------------~  M E S S A G E - C E N T R U M - R E C E I V E R -   ~----------------------- */

/**
 * Initializes a message reciever component (built for message centrum);
 *
 * @param {element} The component's root element.
 * @copyright Copyright (c) 2015 Nationale Nederlanden
 */

nn.component.MessageCentrumReciever = function (element) {
  this.element = $(element);
  this.init();
};

$.extend(nn.component.MessageCentrumReciever.prototype, {
  init: function () {
    this.getAndSetOptions();
    this.getAndSetElements();
    this.bindEvents();
    this.doCall();
  },
  getAndSetOptions: function () {
    this.externalFeed = this.element.data('feed');
    this.actionFeed = this.element.data('call-feed');
    this.origin = this.element.data('origin');
    if (this.externalFeed !== null) {
      this.checkUrl = this.externalFeed;
    }
    if (this.actionFeed) {
      this.actionUrl = this.actionFeed;
    }
  },
  getAndSetElements: function () {

    this.messageTypes = {
      "styles": [{
        "BerichtType": "00",
        "style": "notification--warning"
      }, {
        "BerichtType": "1A",
        "style": "notification--success"
      }, {
        "BerichtType": "1B",
        "style": "notification--warning"
      }, {
        "BerichtType": "1C",
        "style": "notification--info"
      }, {
        "BerichtType": "1D",
        "style": "notification--error"
      }, {
        "BerichtType": "2A",
        "style": "notification--type2-warning"
      }, {
        "BerichtType": "2B",
        "style": "notification--type2-info"
      }, {
        "BerichtType": "2D",
        "style": "notification--type2-error"
      }]
    };

    this.messageTemplate = '<div class="{style}" data-component="Notification"><h3 class="notification-title">{title}</h3><div class="notification-content"><p class="notification-text">{description}</p>{link}</div>{close}</div>';
    this.messagesContainer = this.element;
  },
  bindEvents: function () {
  },
  doCall: function () {
    $.ajax({
      url: this.checkUrl + '?ts='
        + (new Date().getTime()),
      type: 'GET',
      dataType: 'json',
      success: $.proxy(function (data) {
        if (data.status === "OK") {
          this.buildResultsHTML(data);
        }
      }, this)
    });
  },

  buildResultsHTML: function (results) {
    results = results.berichten;
    var messageTypes = this.messageTypes.styles;
    var messages = [];
    var messageStyle;

    if (results && results.length > 0) {
      for (var i = 0; i < results.length; i++) {

        // loop through style array to find it's
        // matching style class;
        for (var a = 0; a < messageTypes.length; a++) {
          if (messageTypes[a].BerichtType === results[i].BerichtType) {
            messageStyle = messageTypes[a].style;
          }

        }

        // Only show messages when content is not empty
        if (results[i].BerichtContent !== "") {
          var str;
          // rreplace the template;
          if (messageStyle !== undefined) {

            var callParams = {"Origin": this.origin};
            //only add filled in params
            var key;
            for (key in results[i]) {
              if (key.match(/VTA_ID|Contract_ID|BerichtCode|BerichtType/g) && results[i][key]) {
                callParams[key] = results[i][key];
              }
            }

            var link = results[i].Link;
            var linkClass = '';

            var closeHtml = '';
            var linkText = '';

            if (results[i].BerichtType.indexOf("2") >= 0) {
              var strDataAtt = '';
              for (key in callParams) {
                strDataAtt += ' data-' + key + ' = "' + callParams[key] + '" ';
              }
              closeHtml = '<span class="notification-close-button" {dataAtts}></span>';
              closeHtml = closeHtml.replace('{dataAtts}', strDataAtt);
              linkClass = 'more notification-button';
              linkText = 'Lees meer';
            } else {
              linkClass = 'button button--light-noborder notification-button';
              linkText = 'Call to action';
            }
            if (link && link !== "False") {
              link = link.replace('http://', window.location.origin + '/');
              link += ((link.indexOf('?') > 0) ? '&' : '?');

              if (results[i].LinkText) {
                linkText = results[i].LinkText;
              }

              // add parameters to call to action link for complete portal message
              for (key in callParams) {
                link += key + "=" + callParams[key] + "&";
              }

              var htmlLink = '<a class="' + linkClass
                + '" href="' + link + '">'
                + linkText + '</a>';
              str = this.messageTemplate
                .replace('{style}', messageStyle)
                .replace('{title}', results[i].Titel)
                .replace('{description}', results[i].BerichtContent)
                .replace('{link}', htmlLink)
                .replace('{close}', closeHtml);
            } else {
              str = this.messageTemplate
                .replace('{style}', messageStyle)
                .replace('{title}', results[i].Titel)
                .replace('{description}', results[i].BerichtContent)
                .replace('{link}', '')
                .replace('{close}', closeHtml);
            }
          }
          messages.push(str);
        }
      }
      this.parseContent(messages.join(''));
    } else {
      this.element.hide();
    }

  },
  parseContent: function (data) {
    this.messagesContainer.html(this.messagesContainer.html().replace('{messages}', data));
    this.onParseComplete();
  },
  onParseComplete: function () {
    this.closeButton = this.element.find('.notification-close-button');
    this.closeButton.on('click', $.proxy(this.clickClose, this));
  },
  clickClose: function (e) {
    var parameters = "Origin,VTA_ID,Contract_ID,BerichtCode,BerichtType".split(",");
    var params = {};
    e.preventDefault();
    var d = $(e.target).data();
    for (var key in parameters) {
      var paramKey = parameters[key].toLowerCase();
      if (d[paramKey]) {
        params[parameters[key]] = d[paramKey];
      }
    }
    this.doCloseCall(params);
    this.onCloseCallComplete(e.target);
  },
  doCloseCall: function (params) {
    $.ajax({
      url: this.actionUrl,
      type: "GET",
      // dataType: "jsonp",
      timeout: nn.settings.ajaxTimeout,
      data: params
    });
  },
  onCloseCallComplete: function (element) {
    $(element).parents('[data-component="Notification"]').hide();
  }

});
